import React from 'react'
import { Link } from 'gatsby'

// import Layout from '../components/layout'
import Head from '../components/head'

const NotFoundPage = () => {
    return (
    <div>
    <Head title="404!"/>
        <div>
            <h3><span>Sorry. The project is currently suspended</span></h3>
            <p><Link to="/">Back home</Link></p>
        </div>
    </div>
    )
}

export default NotFoundPage;